var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggler",class:{ inverse: _vm.inverse , inverseColor: _vm.inverseColor  },on:{"click":_vm.openBar}},[_c('i',{staticClass:"icon ion-md-menu"})])
}
var staticRenderFns = []

export { render, staticRenderFns }